/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const PremiumSound = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 24 18" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M12.12.32a.51.51 0 0 0-.53.06l-5.19 4H.94a.5.5 0 0 0-.5.5v8a.51.51 0 0 0 .5.5H6.4l5.18 4.18a.5.5 0 0 0 .53.06.49.49 0 0 0 .29-.45V.77a.5.5 0 0 0-.28-.45zM14 5a.5.5 0 0 0 0 .71 4.67 4.67 0 0 1 0 6.6.5.5 0 0 0 0 .69.52.52 0 0 0 .35.14.5.5 0 0 0 .35-.14 5.68 5.68 0 0 0 0-8 .5.5 0 0 0-.7 0z" /><path d="M17.56 3.17a.5.5 0 0 0-.71 0 .5.5 0 0 0 0 .7 7.26 7.26 0 0 1 0 10.26.5.5 0 0 0 .36.85.49.49 0 0 0 .35-.15 8.24 8.24 0 0 0 0-11.66z" /><path d="M20.39 1.34a.5.5 0 0 0-.71 0 .51.51 0 0 0 0 .71c3.838 3.839 3.838 10.061 0 13.9a.51.51 0 0 0 0 .71.51.51 0 0 0 .36.15.5.5 0 0 0 .35-.15c4.221-4.234 4.221-11.086 0-15.32z" /></g>
      </g>
    </svg>
  </span>
);

PremiumSound.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

PremiumSound.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default PremiumSound;
